import { render, staticRenderFns } from "./EvidenceSubmissionStepsGuide.vue?vue&type=template&id=876db1de&scoped=true&"
import script from "./EvidenceSubmissionStepsGuide.vue?vue&type=script&lang=js&"
export * from "./EvidenceSubmissionStepsGuide.vue?vue&type=script&lang=js&"
import style0 from "./EvidenceSubmissionStepsGuide.vue?vue&type=style&index=0&id=876db1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876db1de",
  null
  
)

export default component.exports